// import Positions from './Positions';

export default {
  priority: 10,
  path: 'positions',
  permissions: ['StackRulesMenu'],
  // component: Positions,
  component: load(() => import(/* webpackChunkName: "Stack-Pack-Positions" */ './Positions')),
  name: app.translate('routes.home.attendance.shift.Assignment'),
  icon: 'account-location',
  drawer: true,
};


